import {enableProdMode} from '@angular/core';
import {platformBrowserDynamic} from '@angular/platform-browser-dynamic';
import {AppModule} from './app/app.module';
import {environment} from './environments/environment';
import * as L from 'leaflet';

import 'leaflet-providers/leaflet-providers';
import 'leaflet-bing-layer/leaflet-bing-layer';

import './app/shared/utils/leaflet-kml.js';

import('@geoman-io/leaflet-geoman-free').then(module => {
  (L as any).PM.initialize();
});
import '@cds/core/icon/register.js';
import '@cds/core/forms/register.js';
import {
  airplaneIcon,
  barsIcon,
  bellIcon,
  chatBubbleIcon,
  ClarityIcons,
  cogIcon,
  copyToClipboardIcon,
  displayIcon,
  downloadIcon,
  helpInfoIcon,
  homeIcon,
  idBadgeIcon,
  layersIcon,
  linkIcon,
  lockIcon,
  logoutIcon,
  mapIcon,
  noteIcon,
  pencilIcon,
  plusIcon,
  switchIcon,
  textIcon,
  trashIcon,
  uploadIcon,
  userIcon,
  viewListIcon,
  volumeMuteIcon
} from '@cds/core/icon';
import {IconShapeTuple} from '@cds/core/icon/interfaces/icon.interfaces';

if (environment.production) {
  enableProdMode();
}

(window as any).CESIUM_BASE_URL = '/assets/cesium/';

// Cesium.buildModuleUrl('/assets/cesium/');
// Cesium.Ion.defaultAccessToken = '';

platformBrowserDynamic().bootstrapModule(AppModule)
  .catch(err => console.error(err));

// bootstrapApplication(AppModule, appConfig).catch((err) =>
//   console.error(err)
// );


(window as any).CESIUM_BASE_URL = '/assets/cesium/';



const droneIcon: IconShapeTuple = ['drone', '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100" aria-hidden="true"><path fill="none" d="M22.3,76.7c-1.8-0.4-3.4,1.2-3,3c0.2,0.9,0.9,1.6,1.8,1.8c1.8,0.4,3.4-1.2,3-3C23.9,77.6,23.2,76.9,22.3,76.7z    M21.7,80.4c-0.7,0-1.3-0.6-1.3-1.3s0.6-1.3,1.3-1.3s1.3,0.6,1.3,1.3S22.4,80.4,21.7,80.4z"></path><path fill="none" d="M22.1,22c-1.8-0.4-3.4,1.2-3,3c0.2,0.9,0.9,1.6,1.8,1.8c1.8,0.4,3.4-1.2,3-3C23.7,22.9,23,22.2,22.1,22z    M21.5,25.7c-0.7,0-1.3-0.6-1.3-1.3s0.6-1.3,1.3-1.3s1.3,0.6,1.3,1.3S22.2,25.7,21.5,25.7z"></path><path fill="none" d="M79.3,27c1.8,0.4,3.4-1.2,3-3c-0.2-0.9-0.9-1.6-1.8-1.8c-1.8-0.4-3.4,1.2-3,3C77.7,26.1,78.4,26.8,79.3,27z    M79.9,23.4c0.7,0,1.3,0.6,1.3,1.3c0,0.7-0.6,1.3-1.3,1.3s-1.3-0.6-1.3-1.3C78.6,24,79.2,23.4,79.9,23.4z"></path><path fill="none" d="M80,76.5c-1.8-0.4-3.4,1.2-3,3c0.2,0.9,0.9,1.6,1.8,1.8c1.8,0.4,3.4-1.2,3-3C81.6,77.4,80.9,76.7,80,76.5z    M79.4,80.1c-0.7,0-1.3-0.6-1.3-1.3s0.6-1.3,1.3-1.3s1.3,0.6,1.3,1.3S80.1,80.1,79.4,80.1z"></path><circle cx="79.9" cy="24.6" r="1.3"></circle><circle cx="21.5" cy="24.4" r="1.3"></circle><circle cx="21.7" cy="79.1" r="1.3"></circle><path d="M50.5,63.4 M50.8,40.6c-0.1,0-0.2,0-0.3,0c-5.8,0-16.6-9.4-20.9-13.4c-1-0.9-1.8-1.9-2.2-3.2c-0.5-1.2-1.2-2-1.8-2.6   c1-1.3,2.6-2.9,5.1-4.5c5.9-3.8,9.4-7.8,10.5-9.9c1.2-2.1,1.1-3.1-1-3.2c-2.1-0.1-6.8,3.6-6.8,3.6s-6.3,5.3-10.5,12.5   c-1.2-0.2-2.9-0.2-4.3,1c-2.3,1.9-1.8,4.8-1,6.2c-0.7,0.6-1.5,1.2-2.5,1.8C9.1,33,5.7,37,4.5,39c-1.2,2.1-1.1,3.1,1,3.2   c2.1,0.1,6.8-3.6,6.8-3.6s4.2-3.6,8.1-8.8c0.8,0.4,2,1,3.5,1.7c0.4,0.2,0.7,0.4,1.1,0.6c3.1,2.6,6.9,8.6,9.7,13.5   c2.2,3.8,2.2,8.6,0,12.4c-2.8,5-6.8,11.3-9.9,13.9c-0.3,0.3-0.7,0.5-1,0.6c-0.7,0.3-1.2,0.6-1.7,0.8c-4.2-6.4-9.6-11-9.6-11   s-4.7-3.7-6.8-3.6c-2.1,0.1-2.2,1.1-1,3.2c1.2,2.1,4.6,6.1,10.5,9.9c1.7,1.1,3,2.2,4,3.2c-0.6,0.4-1,0.7-1.3,1.1   c-0.9,1-2.1,4.6,0.6,6.8c1.9,1.6,4.1,1.2,5.3,0.8c0.3-0.1,0.6-0.2,0.8-0.4c4.1,5.9,8.9,10,8.9,10s4.7,3.7,6.8,3.6s2.2-1.1,1-3.2   c-1.2-2.1-4.6-6.1-10.5-9.9c-1.7-1.1-2.9-2.2-3.9-3.1c0.1-0.2,0.2-0.4,0.3-0.7c0.5-1.3,1.3-2.4,2.3-3.3c4.3-4,15-13.4,20.9-13.4    M50.3,63.4c5.8,0,17.1,9.4,21.5,13.4c1,0.9,1.8,2.1,2.3,3.3c0.2,0.4,0.3,0.7,0.5,1c-0.9,0.9-2.1,1.9-3.6,2.8   c-5.9,3.8-9.4,7.8-10.5,9.9c-1.2,2.1-1.1,3.1,1,3.2c2.1,0.1,6.8-3.6,6.8-3.6s4.8-4.1,8.8-9.9c0.1,0.1,0.3,0.1,0.4,0.2   c1.2,0.4,3.4,0.8,5.3-0.8c2.7-2.2,1.5-5.8,0.6-6.8c-0.3-0.3-0.6-0.6-1-0.9c1-1.1,2.3-2.2,4.2-3.4c5.9-3.8,9.4-7.8,10.5-9.9   c1.2-2.1,1.1-3.1-1-3.2c-2.1-0.1-6.8,3.6-6.8,3.6s-5.5,4.7-9.7,11.2c-0.6-0.3-1.3-0.6-2.1-1c-0.4-0.2-0.7-0.4-1.1-0.6   c-3.1-2.6-6.9-8.6-9.7-13.5c-2.2-3.8-2.2-8.6,0-12.4c2.8-5,6.8-11.3,9.9-13.9c0.3-0.3,0.7-0.5,1.1-0.6c1.6-0.7,2.7-1.2,3.5-1.7   c3.9,5.3,8.1,8.8,8.1,8.8s4.7,3.7,6.8,3.6c2.1-0.1,2.2-1.1,1-3.2c-1.2-2.1-4.6-6.1-10.5-9.9c-1-0.6-1.8-1.3-2.5-1.9   c0.7-1.5,1.2-4.3-1-6.2c-1.4-1.2-3-1.2-4.2-1C74.5,12.9,68.2,7.6,68.2,7.6S63.5,3.9,61.4,4c-2.1,0.1-2.2,1.1-1,3.2   c1.2,2.1,4.6,6.1,10.5,9.9c2.4,1.6,4,3.1,5.1,4.4c-0.6,0.5-1.3,1.4-1.8,2.5c-0.5,1.3-1.3,2.4-2.3,3.3c-4.3,4-15.3,13.4-21.2,13.4    M79.3,22.3c1.8-0.4,3.4,1.2,3,3c-0.2,0.9-0.9,1.6-1.8,1.8c-1.8,0.4-3.4-1.2-3-3C77.7,23.2,78.4,22.5,79.3,22.3z M22.1,26.8   c-1.8,0.4-3.4-1.2-3-3c0.2-0.9,0.9-1.6,1.8-1.8c1.8-0.4,3.4,1.2,3,3C23.7,25.9,23,26.6,22.1,26.8z M22.3,81.5c-1.8,0.4-3.4-1.2-3-3   c0.2-0.9,0.9-1.6,1.8-1.8c1.8-0.4,3.4,1.2,3,3C23.9,80.6,23.2,81.3,22.3,81.5z M80,81.2c-1.8,0.4-3.4-1.2-3-3   c0.2-0.9,0.9-1.6,1.8-1.8c1.8-0.4,3.4,1.2,3,3C81.6,80.3,80.9,81,80,81.2z"></path><circle cx="79.4" cy="78.9" r="1.3"></circle></svg>'];

ClarityIcons.addIcons(airplaneIcon, mapIcon, barsIcon, bellIcon, chatBubbleIcon, cogIcon, copyToClipboardIcon, displayIcon,
  downloadIcon, helpInfoIcon, homeIcon, idBadgeIcon, linkIcon, lockIcon, logoutIcon, noteIcon, pencilIcon, plusIcon,
  textIcon, trashIcon, uploadIcon, userIcon, viewListIcon, droneIcon, switchIcon, volumeMuteIcon, layersIcon);

// First we get the viewport height and we multiply it by 1% to get a value for a vh unit
let vh = window.innerHeight * 0.01;
// Then we set the value in the --vh custom property to the root of the document
document.documentElement.style.setProperty('--vh', `${vh}px`);

// We listen to the resize event
window.addEventListener('resize', () => {
  // We execute the same script as before
  let vh = window.innerHeight * 0.01;
  document.documentElement.style.setProperty('--vh', `${vh}px`);
});
